import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      common: require('./locales/en/common.json')
    },
    fr: {
      common: require('./locales/fr/common.json')
    }
  },
  ns: ['common'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false // React already escapes by default
  }
});

i18n.languages = ['en', 'fr'];

export default i18n;
